export class KycConsentConfig {
  regulatoryCommission: string = '';
  electricityReform: string = '';
  networkRegulation: string = '';
  electricityManagement: string = '';
  country: string = '';
  serviceRequestImageUrl: string | null = null;
  cookieConsentEnabled: boolean = false;
}
